import React, { CSSProperties } from "react";

interface ServicesExportProps {
  gap?: number;
  showNavigation?: boolean;
  cardsPerViewDesktop?: number;
  children?: React.ReactNode;
}

export const ServicesExport: React.FC<ServicesExportProps> = ({
  gap = 24,
  showNavigation = true,
  cardsPerViewDesktop = 3,
  children,
}) => {
  const childCount = React.Children.count(children);
  const hasChildren = childCount > 0;

  const cpv = cardsPerViewDesktop || 3;
  const cardWidthCalc = `calc((100% - ${(cpv - 1) * gap}px) / ${cpv})`;

  // Matching editor: Services.tsx line 185-191
  const containerStyles: CSSProperties = {
    position: "relative",
    width: "100%",
  };

  // Matching editor: Services.tsx line 219-237
  const scrollContainerStyles: CSSProperties & Record<string, string> = {
    "--card-width": cardWidthCalc,
    display: "flex",
    flexWrap: "nowrap",
    gap: `${gap}px`,
    overflowX: "auto",
    scrollBehavior: "smooth",
    padding: "16px",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
  } as CSSProperties & Record<string, string>;

  // Matching editor: Services.tsx line 199-209 — vertically centered, white circle with shadow
  const arrowStyles: CSSProperties = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 10,
    backgroundColor: "white",
    border: "none",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    boxShadow: "0 1px 5px rgba(0,0,0,0.15)",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if (!hasChildren) {
    return (
      <div className="services-carousel" style={containerStyles}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "48px 24px",
            backgroundColor: "#f9fafb",
            borderRadius: "8px",
            border: "2px dashed #d1d5db",
            minHeight: "200px",
          }}
        >
          <div style={{ textAlign: "center", color: "#6b7280" }}>
            <h3 style={{ margin: "0 0 8px", fontWeight: 600 }}>No services yet</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="services-carousel" style={containerStyles}>
      <div style={{ position: "relative" }}>
        {showNavigation && (
          <button className="carousel-prev" style={{ ...arrowStyles, left: "4px" }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <polyline points="15,18 9,12 15,6" />
            </svg>
          </button>
        )}

        <div className="carousel-scroll" style={scrollContainerStyles}>
          {children}
        </div>

        {showNavigation && (
          <button className="carousel-next" style={{ ...arrowStyles, right: "4px" }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
              <polyline points="9,18 15,12 9,6" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};
